const PUBLIC_INTAKE_FORM_PREFIXES = ["/d", "/f", "/p"] as const

export const PUBLIC_INTAKE_FORM_ROUTE_PATTERNS = PUBLIC_INTAKE_FORM_PREFIXES.flatMap((prefix) => [
  prefix,
  `${prefix}/(.*)`,
])

export function isPublicIntakeFormRoute(pathname: string): boolean {
  return PUBLIC_INTAKE_FORM_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`))
}
